import React from 'react';
import { Button } from '@mui/material';

interface SaveRefundConfigButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const SaveRefundConfigButton: React.FC<SaveRefundConfigButtonProps> = ({
  onClick,
  isLoading = false,
  disabled = false,
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled || isLoading}
      sx={{ textTransform: 'none' }}
    >
      {isLoading ? 'Saving...' : 'Save Configuration'}
    </Button>
  );
};
